'use client';

import React, { JSX } from 'react';

import { WarningTriangle } from '@videoblocks/react-icons';
import { Alert } from '@videoblocks/storywind';

export default function MaintenanceBanner(): JSX.Element | null {
    const [showBanner, setShowBanner] = React.useState(true);

    React.useEffect(() => {
        const isBannerVisible = sessionStorage.getItem('show-maintenance-banner') !== 'false';
        setShowBanner(isBannerVisible);
    }, []);

    if (!showBanner) {
        return null;
    }

    const hideBanner = () => {
        sessionStorage.setItem('show-maintenance-banner', 'false');
        setShowBanner(false);
    };

    return (
        // @ts-expect-error suppressing type error for WarningTriangle icon prop as part of eslint migration
        <Alert severity="info" icon={WarningTriangle} data-testid="maintenance-banner" onClose={hideBanner}>
            We will be performing routine maintenance on December 11th starting at 10 PM ET. The expected duration is 1
            hour. During this period, the Web Application and API may be unavailable. Thank you for your patience as we
            work to improve our services.
        </Alert>
    );
}
